import React, { FunctionComponent, useMemo } from 'react';
import styles from '../../../OrderStatusPage.module.scss';
import { OrderStatusTrackerFigureRow } from './OrderStatusTrackerFigureRow';
import { useLocationStore, useTranslation } from 'mycheck-core';
import { observer } from 'mobx-react';
import { type OrderGuestStatuses } from 'plugins/CheckoutPlugin/types/CheckoutTypes';
import { FormattOrderStatus } from '../helpers';

interface OrderStatusTrackerFigureProps {
  orderStatusesDate: OrderGuestStatuses[];
}

export const OrderStatusTrackerFigure = observer<
  FunctionComponent<OrderStatusTrackerFigureProps>
>(({ orderStatusesDate }) => {
  const { t } = useTranslation();
  const LocationStore = useLocationStore();

  const orderStatuses = useMemo(
    () =>
      FormattOrderStatus(
        orderStatusesDate,
        LocationStore.guestOrderStatusMessage,
        LocationStore.locationTimezoneName,
        t,
      ),
    [
      orderStatusesDate,
      LocationStore.guestOrderStatusMessage,
      LocationStore.locationTimezoneName,
      t,
    ],
  );

  return (
    <div className={styles.orderStatusPageFigureContainer}>
      {orderStatuses.map((orderStatus) => (
        <OrderStatusTrackerFigureRow
          orderStatus={orderStatus}
          key={orderStatus.id}
        />
      ))}
    </div>
  );
});
